/* @flow */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Segment, Dimmer, Loader } from 'semantic-ui-react';
import {
  getIsFetching,
  getIsFetched,
  getIsDeploying,
  getDeployments,
} from 'catalog/reducers/deployments';
import * as DeploymentsActions from 'catalog/actions/deployments';
import NoDeployments from './components/NoDeployments';
import DeploymentLoader from './components/DeploymentLoader';
import DeploymentList from './components/DeploymentList';

type Props = {
  isFetching: boolean,
  isFetched: boolean,
  isDeploying: boolean,
  deployments: Array<CatalogDeployment>,
  fetchDeployments: () => void,
  deploy: () => void,
};

const styles = {
  loader: {
    minHeight: '140px',
  },
};

const mapStateToProps = state => ({
  isFetching: getIsFetching(state),
  isFetched: getIsFetched(state),
  isDeploying: getIsDeploying(state),
  deployments: getDeployments(state),
});

class Deployments extends Component {
  props: Props;

  componentDidMount() {
    const { isFetched, fetchDeployments } = this.props;

    if (!isFetched) {
      fetchDeployments();
    }
  }

  render() {
    const {
      isFetching,
      isFetched,
      isDeploying,
      deployments,
      deploy,
    } = this.props;

    if (isFetching && !isFetched) {
      return (
        <Segment style={styles.loader}>
          <Dimmer active inverted>
            <Loader inverted content="Chargement des déploiements" />
          </Dimmer>
        </Segment>
      );
    }

    if (isDeploying) {
      return <DeploymentLoader />;
    }

    if (deployments.length === 0) {
      return <NoDeployments onDeployed={deploy} />;
    }

    return <DeploymentList deployments={deployments} onDeployed={deploy} />;
  }
}

export default connect(mapStateToProps, DeploymentsActions)(Deployments);



// WEBPACK FOOTER //
// ./src/modules/catalog/screens/Deployments/index.js